export interface IGetZoneByIdFilterDto {
    includeExternal?: boolean;
    includeSharedFinished?: boolean;
}
